import { render } from "./News.vue?vue&type=template&id=7c63965e&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=7c63965e&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/外网-学校主页/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c63965e"]])

export default __exports__